<template>
<div   class="container-fluid">


 

  <div class="card border-success">
  <div  class="card-header text-white bg-primary">
    <h4> <i  class="far fa-calendar-alt mr-2" aria-hidden="true"></i>CALENDARIO COMPLEANNO CLIENTI</h4>   
  </div>

  <div  class="card-body"> 
 
   <div class="row">
   <div v-if="items.length==0" class="col-md-4"> 

   <div class="card border-info" >
   <div class="card-header bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
   <div class="card-body text-dark">

  <form  v-on:submit.prevent="getData()">
     <!-- <year-select  v-bind:props="season_year" @update="setYear"></year-select>-->

          <label class="" for="data"><strong>Da data  </strong></label>      
          <input type="date"  class="form-control " id="create_at1"  v-model="data1">


          <label class="" for="data"><strong>a data  </strong></label>      
          <input type="date"  class="form-control " id="create_at2"  v-model="data2">



       
 
<div class="card-footer mt-3 bg-transparent border-info"> 
  <alert-box  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  <button :disabled="bt_spinner" class="btn btn-primary active float-right">
    <i  class="fas fa-binoculars mr-2" aria-hidden="true"></i>
    CERCA
    <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>
  </button>
</div>
  
  </form>
  </div>
  </div>
  </div>


  <div v-else class="col">
  <button v-if="items.length>0"  @click="items=[]" type="button"  class="btn btn-secondary mb-2">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    ANNULLA
  </button>

  <button @click="export_data()"  type="button" class="btn btn-primary mb-2 ml-3">
                  <i class="fas fa-file-export mr-2" aria-hidden="true"></i>
                  ESPORTA 
                  <span v-if="bt1_spinner"  class="spinner-border spinner-border-sm ml-2 " role="status" aria-hidden="true"></span>
                  </button> 

  <div class="data_table">

  <table class="table table-sm mb-0">
    <thead >
      <tr>
        
        
        <th>GIORNO - MESE</th>
       
        <th>CLIENTE</th>
        <th>TELEFONO</th>
    
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in filteredItems" :key="index">
      <td>
        {{item.day_of_birth}} - {{item.month_of_birth}}
      </td>  
      <td>
        {{item.last_name}} {{item.first_name}}
      </td>      
      
      <td>
        {{item.mobile}}
      </td>
     
      </tr> 
    </tbody>

    
  </table>
  
</div>

<!--
<label for="cerca"><strong>
  <i  class="fas fa-filter mr-2" aria-hidden="true"></i>
  Filtra</strong></label>
<input class="form-control" type="text" name="query" v-model="filterKey">
-->

</div>  
</div>
</div>
</div>

</div>
</template>
<script>
import alertBox           from '@/components/common/AlertBox.vue';

import api                from '@/api'
import { mapGetters }     from 'vuex';

export default {
  
  components: {alertBox},
  data() {
    return {

      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
      filterKey              : '',
      
      data1            : '',
      data2            : '',
      
      bt_spinner       : false,
      bt1_spinner      : false,
     
      msg                    : {
        title                : '',
        body                 : '',
        type                 : 0
      }, 
      items                  : [],
     
      
      
      
    }
  },
  computed :{
   
    ...mapGetters(['storeId','company']) , 
     filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
    


  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        //el.focus();
      }
    }
  },
  mounted: function() {
    //this.getData()
  },
  created: function() {},
  methods: {
    
    


   export_data()
   {
      let csvContent = "data:text/csv;charset=utf-8," 
      this.items.forEach(function(item) 
      {

            let row = item.customerId 
                  + ',' + item.last_name + ' ' + item.first_name
                   + ',' + item.mobile + ','+ item.email + ',' + item.day_of_birth + ',' + item.month_of_birth + ',' + item.balance
 



                  csvContent += row + "\r\n";
      });
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "compleanni.csv");
            document.body.appendChild(link); // Required for FF

            link.click(); // This will download the data file named "my_data.csv".

   },
  
    
    async getData() {
      
      this.msg.title = '' 
      this.items = []
      
      var sp    = {'sp':'spBirthDayCal'}
     
      var data  = {'companyId':this.company.Id,'data1':this.data1,'data2':this.data2}
      console.log(data)
      var json  = Object.assign(data, sp)

      this.bt_spinner = true
      await api.post(json).then(res => {
        if(res.status==200)
          {
            this.items = res.data.recordsets[0]
          
            if(this.items.length==0 )
            {
              
              this.msg.title = "ATTENZIONE "
              this.msg.body = 'DATI INESISTENTI.'
              this.msg.type = 1
     
            }
            else
            {
              //this.formatList()
            }
         
          }
          else if(res.status==500)
          {
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res.data
            this.msg.type  = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1                  
            

          } 
      }).catch(err => 
      {
          
      this.msg.title = 'ATTENZIONE '
      this.msg.body  = err.message
      this.msg.type  = 1  

      }).finally(() => {
        this.bt_spinner = false
      });


  




    }
  }
};
</script>
<style scoped>

.data_table {
position  : relative;
height    : 700px;
overflow  : auto;
}


.fa-print
{
  cursor: pointer
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   :  hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

  


h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.date_time
{
  font-size: 18px;
}
 .table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}
</style>